import Steps from "../components/Procurement/Steps";
import ProcurementChat from "../components/Procurement/ProcurementChat";
import OrderRequestCard from "../components/Procurement/OrderRequestCard";

export default function Procurement() {
  return (
    <section className="card space-y-8 !px-8 !py-6">
      <h3 className="text-[#475467] text-sm">
        Taram facilitates procurement of goods from across the world for
        companies.
      </h3>

      <Steps />

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 xl:grid-cols-[2fr_1fr] gap-5">
        <ProcurementChat />
        <OrderRequestCard />
      </div>
    </section>
  );
}
